import { Component, OnInit, ViewChild } from "@angular/core";
import { ApplicationTableComponent } from "./application-table/application-table.component";

@Component({
	selector: "app-application-setup",
	templateUrl: "./application-setup.component.html",
	styleUrls: ["./application-setup.component.css"],
})
export class ApplicationSetupComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////

	@ViewChild(ApplicationTableComponent)
	MainTableRef: ApplicationTableComponent;

	ApplicationID: any = "";

	SchoolExpand: any = true;
	MenuItemExpand: any = false;

	///////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////
	onTableChange() {
		this.MainTableRef.loadApplication();
	}

	onApplicationSelected(val) {
		this.ApplicationID = val;
	}
	///////////////////////////////////////////////////////////////////
}
